/**
 * @generated SignedSource<<04ae082b3d27c3cd83d39f526e122d2b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type AgreementBlock = "BAGGAGE" | "TRANSFER";
import { FragmentRefs } from "relay-runtime";
export type TermEditForm_term$data = {
  readonly agreementBlock: AgreementBlock | null;
  readonly icon: string | null;
  readonly id: string;
  readonly name: string;
  readonly " $fragmentType": "TermEditForm_term";
};
export type TermEditForm_term$key = {
  readonly " $data"?: TermEditForm_term$data;
  readonly " $fragmentSpreads": FragmentRefs<"TermEditForm_term">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TermEditForm_term",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "icon",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "agreementBlock",
      "storageKey": null
    }
  ],
  "type": "Term",
  "abstractKey": null
};

(node as any).hash = "6e141c7faadf54dfc81613800242135d";

export default node;
